import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { Link } from "react-router-dom";

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/overview").then(({ data }) => setData(data)).catch(() => {}); }, []);

  return (
    <div className="space-y-8" data-testid="coach-analytics-page">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#38BDF8] font-bold">Reports</div>
        <h2 className="font-display text-4xl font-black uppercase tracking-tighter mt-2">Coaching Analytics</h2>
      </div>

      {!data ? (
        <div className="text-[#A3A3A3]">Loading…</div>
      ) : (
        <>
          <div className="grid md:grid-cols-4 gap-4">
            {[
              { l: "Students", v: data.total_students },
              { l: "Total lessons", v: data.total_lessons },
              { l: "Completed", v: data.completed_lessons },
              { l: "Revenue", v: `$${Number(data.revenue || 0).toFixed(0)}` },
            ].map((t) => (
              <div key={t.l} className="card-surface p-6" data-testid={`analytics-stat-${t.l.toLowerCase().replace(/\s/g, '-')}`}>
                <div className="font-display text-5xl font-black">{t.v}</div>
                <div className="text-[10px] uppercase tracking-widest text-[#A3A3A3] mt-2">{t.l}</div>
              </div>
            ))}
          </div>

          <div className="card-surface p-6">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#38BDF8] font-bold mb-4">Lessons per month</div>
            <div className="h-72">
              <ResponsiveContainer>
                <BarChart data={data.lessons_by_month}>
                  <CartesianGrid stroke="rgba(255,255,255,0.05)" />
                  <XAxis dataKey="month" stroke="#A3A3A3" tick={{ fontSize: 10 }} />
                  <YAxis stroke="#A3A3A3" tick={{ fontSize: 10 }} />
                  <Tooltip contentStyle={{ background: "#141414", border: "1px solid rgba(255,255,255,0.1)" }} />
                  <Bar dataKey="count" fill="#38BDF8" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="card-surface p-6">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#38BDF8] font-bold mb-4">Top students</div>
            {(data.top_students || []).length === 0 ? (
              <div className="text-sm text-[#A3A3A3]">No data yet.</div>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-[#A3A3A3] uppercase text-xs tracking-widest">
                    <th className="text-left py-2">Student</th>
                    <th className="text-right py-2">Lessons</th>
                  </tr>
                </thead>
                <tbody>
                  {data.top_students.map((s) => (
                    <tr key={s.user_id} className="border-t border-white/5">
                      <td className="py-3">
                        <Link to={`/coach/students/${s.user_id}`} className="hover:text-[#38BDF8]" data-testid={`top-student-${s.user_id}`}>
                          {s.name}
                        </Link>
                      </td>
                      <td className="text-right py-3 font-display font-bold text-lg">{s.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </div>
  );
}
